import { InviteMemberModal } from '../pages/invite-member'
import { TeamPage } from '../pages/team'
import { UpdateMemberModal } from '../pages/update-member'
import { InvitationsPage } from '../pages/invitations'
import { MembersPage } from '../pages/members'
import { Navigate } from 'react-router-dom'
import { TeamMemberPage } from '../pages/team-member'
import { EditTeamMemberProfileModal } from '../pages/edit-team-member-profile'
import { EditTeamMemberDetailsModal } from '../pages/edit-team-member-details'
import { EditWorkingHoursModal } from '../pages/edit-working-hours'
import { RouteObject } from 'react-router'

export enum TeamRoutePath {
  Team = '/team',
  TeamMembers = '/team/members',
  TeamInvitations = '/team/invitations',
  TeamInviteMember = 'invite',
  TeamUpdateMember = ':id/update',
  TeamMemberView = '/team/:id',
  TeamMemberEditProfile = 'edit-profile',
  TeamMemberEditDetails = 'edit-details',
  TeamMemberEditWorkingHours = 'edit-working-hours',
}

const inviteMemberRoute = {
  path: TeamRoutePath.TeamInviteMember,
  element: <InviteMemberModal />,
}

export const protectedTeamRoutes: RouteObject[] = [
  {
    path: TeamRoutePath.Team,
    element: <TeamPage />,
    children: [
      {
        index: true,
        element: <Navigate
          to={TeamRoutePath.TeamMembers}
          replace
        />,
      },
      {
        path: TeamRoutePath.TeamMembers,
        element: <MembersPage />,
        children: [
          inviteMemberRoute,
          {
            path: TeamRoutePath.TeamUpdateMember,
            element: <UpdateMemberModal />,
          },
        ],
      },
      {
        path: TeamRoutePath.TeamInvitations,
        element: <InvitationsPage />,
        children: [
          inviteMemberRoute,
        ],
      },
    ],
  },
  {
    path: TeamRoutePath.TeamMemberView,
    element: <TeamMemberPage />,
    children: [
      {
        path: TeamRoutePath.TeamMemberEditProfile,
        element: <EditTeamMemberProfileModal />,
      },
      {
        path: TeamRoutePath.TeamMemberEditDetails,
        element: <EditTeamMemberDetailsModal />,
      },
      {
        path: TeamRoutePath.TeamMemberEditWorkingHours,
        element: <EditWorkingHoursModal />,
      },
    ],
  },
]
